export default __webpack_public_path__ + "static/media/bg6.12425b5c.jpg";